export function toggleSwitch(ctx, node) {
     let i = node.rect.x
      , n = node.rect.y
      , r = node.rect.width
      , o = node.rect.height
      , s = o;
    return o > r && (s = r),
    s = 3 * s / 2,
    ctx.beginPath(),
    function(ctx, node, i, n, r, o) {
        var s, a;
        for (a = 2 * Math.PI / r,
        ctx.save(),
        ctx.fillStyle = node.background,
        ctx.strokeStyle = node.background,
        ctx.lineWidth = 1,
        ctx.translate(i, n),
        ctx.moveTo(-o, 0),
        ctx.beginPath(),
        s = 0; s < r; s++)
            ctx.rotate(a),
            ctx.lineTo(-o, 0);
        ctx.closePath(),
        ctx.stroke(),
        ctx.fill(),
        ctx.restore()
    }(ctx, node, i + r / 2, n + o / 2, 6, s / 4),
    ctx.beginPath(),
    ctx.fillStyle = node.color,
    ctx.arc(i + r / 2, n + o / 2, s / 8, 0, 2 * Math.PI),
    ctx.fill(),
    ctx.beginPath(),
    ctx.fillStyle = node.color,
    node.value ? (ctx.moveTo(i + r / 2 + s / 12, n + o / 2),
    ctx.arc(i + r / 2, n + o / 2, s / 12, 0, Math.PI),
    ctx.lineTo(i + r / 2 - s / 12, n + o / 2 - s / 4 + s / 12),
    ctx.arc(i + r / 2, n + o / 2 - s / 4 + s / 12, s / 12, Math.PI, 2 * Math.PI),
    ctx.closePath(),
    ctx.stroke(),
    ctx.fill(),
    ctx.moveTo(i + r / 2 + s / 8, n + o / 2 - s / 4),
    ctx.arc(i + r / 2, n + o / 2 - s / 4, s / 8, 0, 2 * Math.PI),
    ctx.stroke(),
    ctx.fill()) : (ctx.moveTo(i + r / 2 - s / 12, n + o / 2),
    ctx.arc(i + r / 2, n + o / 2, s / 12, Math.PI, 2 * Math.PI),
    ctx.lineTo(i + r / 2 + s / 12, n + o / 2 + s / 4 - s / 12),
    ctx.arc(i + r / 2, n + o / 2 + s / 4 - s / 12, s / 12, 0, Math.PI),
    ctx.closePath(),
    ctx.stroke(),
    ctx.fill(),
    ctx.moveTo(i + r / 2 + s / 8, n + o / 2 + s / 4),
    ctx.arc(i + r / 2, n + o / 2 + s / 4, s / 8, 0, 2 * Math.PI),
    ctx.stroke(),
    ctx.fill()),
    !1
}

/*export function register_toggleSwitch() {
  (window).Le5leTopology.registerNode('toggleSwitch', toggleSwitch);
}*/